import { lazy, Suspense } from 'react';
import Loader from '../custom/loader/main'

const Main = lazy(() => import('../components/transcript/requests/requestDetails/requestDetails'));

const RequestDetails = () =>{
return(
    <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
)



}

export default RequestDetails;